import { useTranslation } from "react-i18next";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

/** Renders a grid of checkboxes for a lookup code list. */
export default function CheckboxGroup({ options, value = [], onChange, labelPrefix, testIdPrefix }) {
  const { t } = useTranslation();

  const toggle = (code) => {
    if (value.includes(code)) {
      onChange(value.filter((v) => v !== code));
    } else {
      onChange([...value, code]);
    }
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {options.map((code) => (
        <label
          key={code}
          className="flex items-center gap-2 rounded-xl border border-black/10 bg-[#FAFAFA] px-3 py-2.5 cursor-pointer hover:border-[#4ba3b7]/40 transition-colors"
        >
          <Checkbox
            checked={value.includes(code)}
            onCheckedChange={() => toggle(code)}
            data-testid={`${testIdPrefix}-${code}-checkbox`}
          />
          <Label className="text-sm font-normal cursor-pointer">{t(`${labelPrefix}.${code}`)}</Label>
        </label>
      ))}
    </div>
  );
}
